import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Edit2Icon, MoreHorizontalIcon } from '@svgs';

import './Location.scss';

export const Location = ({ businessID, location, businessData }) => {
  const { t, i18n } = useTranslation();

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);
  return (
    <div className="sb-row-item">
      <div className="sb-row--location-name">
        <p>
          <b>
            <Link
              to={`/dashboard/projects/${businessID}/locations/${location.id}`}
            >
              {location.location_name || businessData?.business_name || '...'}
            </Link>
          </b>
        </p>
      </div>
      <div className="sb-row--location-address">
        <p>
          {location.service_area_only == false && (
            <>
              {location.street}
              {location.street2 && (
                <>
                  <br />
                  <span> {location.street2}</span>
                </>
              )}
              <br />
            </>
          )}
          {location.city}, {location.state} {location.postal_code}
        </p>
      </div>
      <div className="sb-row--location-phone">
        <p>{location.phonemap.phone}</p>
      </div>
      <div className="sb-row--location-tags">
        <p>
          {location.published === false && (
            <span
              className="sb-row-tag"
              title="Location is unpublished, will be hidden from location finder"
            >
              Unpublished
            </span>
          )}
        </p>
      </div>
      <div className="sb-options">
        <button
          className="sb-page-options-menu-trigger sb-options-trigger"
          onClick={() => setShowDropdownMenu(!showDropdownMenu)}
        >
          <MoreHorizontalIcon />
        </button>
        <div
          ref={dropdownMenu}
          className={
            'sb-options-menu ' + (showDropdownMenu ? 'sb-show' : 'sb-hide')
          }
        >
          <div className="sb-options-menu-content">
            <Link
              to={`/dashboard/projects/${businessID}/locations/${location.id}`}
              className="sb-options-item"
            >
              <Edit2Icon />
              {t('Edit location details')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
